module.exports = __webpack_public_path__ + "static/media/AURORA.e7a52317.svg";